module.exports = __webpack_public_path__ + "img/stores.21aa19cf.png";